import React from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import AllStudentsPage from '../pages/AllStudentsPage';
import StudentDashboardPage from '../pages/StudentDashboardPage';
import StartTestPage from '../pages/StartTestPage';
import ProtectedRoute from './ProtectedRoute';
import TestTakingPage from '../pages/TestTakingPage';
import ResultsPage from '../pages/ResultsPage';
import AuthRedirect from './AuthRedirect';

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Navigate to="/login" replace />,
  },
  {
    path: '/login',
    element: (
      <AuthRedirect students={<LoginPage />} />
    ),
  },
  {
    path: '/select-student',
    element: (
      <ProtectedRoute students={<AllStudentsPage />} />
    ),
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute students={<StudentDashboardPage />} />
    ),
  },
  {
    path: '/profile',
    element: (
      <ProtectedRoute students={<div>Profile Page</div>} />
    ),
  },
  {
    path: '/start-test',
    element: (
      <ProtectedRoute students={<StartTestPage />} />
    ),
  },
  // Remove these old routes:
  // {
  //   path: '/test/:sessionId',
  //   element: <StartTestPage />
  // },
  // {
  //   path: '/test/:sessionId/taking',
  //   element: <TestTakingPage />
  // },
  // {
  //   path: '/test/:testId/taking',
  //   element: (
  //     <ProtectedRoute students={<TestTakingPage />} />
  //   ),
  // },
  
  // Add the new simplified route:
  {
    path: '/test-taking',
    element: (
      <ProtectedRoute students={<TestTakingPage />} />
    ),
  },
  {
    path: '/test-results',
    element: (
      <ProtectedRoute students={<ResultsPage />} />
    ),
  },
];
